import React from "react";
import { SignupForm } from "../components";

function Signup() {
  return (
    <div className="authPage__container">
      <SignupForm />
    </div>
  );
}

export default Signup;
